define(function (require) {

    var $ = require('jquery');

    require('../../lib/jquery-ui/jquery.ui.core');
    require('../../lib/jquery-ui/jquery.ui.widget');
    require('../../lib/jquery-ui/jquery.ui.mouse');
    require('../../lib/jquery-ui/jquery.ui.sortable');
    require('../../lib/jquery.scrollTo');

    function SwapList(f, ul1, ul2) {
        var $filter = $(f);
        var filter = $filter.get(0);
        if (filter) {
            filter.boundKeyPressHandler = $.proxy(this.FilterKeyPressed, this);
            $filter.keyup(filter.boundKeyPressHandler);
            this.FilterInput = filter;
        }

        this.List1 = ul1;
        this.List2 = ul2;
        var _this = this;
        var clickHandler = $.proxy(this.ShareClick, this);
        ul1.boundClickHandler = clickHandler;
        ul2.boundClickHandler = clickHandler;
        $(ul1).add(ul2)
            .mouseover($.proxy(this.ShareMouseOver, this))
            .mouseout($.proxy(this.ShareMouseOut, this))
            .click(clickHandler)
            .on('dblclick', 'li', this.ShareDblClick)
            .bind('sortover', function () { _this.ToggleHelpText(); })
            .data('list', this);
        this.InitDragDrop();
    }

    $.extend(SwapList.prototype, {

        reset: function () {
            this.InitDragDrop();
        },

        InitDragDrop: function () {
            $(this.List1).sortable({ connectWith: ['#' + this.List2.id] });
            $(this.List2).sortable({ connectWith: ['#' + this.List1.id] });

            this.ToggleHelpText();
        },

        GetHelpText: function () {
            if (!this.helpText) {
                this.helpText = $(this.List2).parent().find('.sl-empty-text').first().get(0);
            }
            return this.helpText;
        },

        InsertItem: function (item, toList) {
            $(item).removeClass('selected');
            var list = $(toList);
            list.append(item);
            list.parent('.scroll').scrollTo($(item, list));
        },

        SelectItem: function (item) {
            var list = item.parent().get(0);

            $(list.selectedItems).removeClass('selected');
            list.selectedItems = item.addClass('selected');

            if (list === this.List1) {
                $(this.List2.selectedItems).removeClass('selected');
                this.List2.selectedItems = [];
            } else if (list === this.List2) {
                $(this.List1.selectedItems).removeClass('selected');
                this.List1.selectedItems = [];
            }
        },

        ToggleHelpText: function () {
            var children = $(this.List2).find('li');
            $(this.GetHelpText())[children.length ? 'hide' : 'show']();
        },

        ShareClick: function (e) {
            var target = $(e.target);
            var item = target.is('li') ? target : target.parent();
            this.SelectItem(item);
        },

        ShareDblClick: function (e) {
            var item = this;
            var $list = $(item).parent();
            var list = $list.get(0);
            var swapList = $list.data('list');
            var list1 = swapList.List1;
            var list2 = swapList.List2;
            if (list === list1) {
                swapList.InsertItem(item, list2, list1, false);
            } else if (list === list2) {
                swapList.InsertItem(item, list1, list2, false);
            }
            list1.selectedItems = [];
            list2.selectedItems = [];

            swapList.ToggleHelpText();
        },

        FilterKeyPressed: function (e) {
            //debugger;
            var key = e.which;
            var query = ($(this.FilterInput).val()).toLowerCase();

            // delete key
            if (key === 8 /*backspace*/) {
                query = query.substring(0, query.length - 1);
            } else if (key < 33 || key > 126) {
                return;
            }

            $(this.List1).children().each(function () {
                var $this = $(this);
                var childName = $.trim($this.text()).toLowerCase();
                $this.css('display', childName.indexOf(query) === -1 ? 'none' : '');
            });
        },

        ShareMouseOver: function (e) {
            var target = $(e.target);
            var elem = target.is('li') ? target : target.parent();
            var ul = elem.closest('ul');
            $(ul.data('lastNode')).removeClass('hover');
            ul.data('lastNode', elem.addClass('hover'));
        },

        ShareMouseOut: function (e) {
            var ul = $(e.target).closest('ul');
            $(ul.data('lastNode')).removeClass('hover');
        },

        MoveAll: function (fromList, toList) {
            var _this = this;
            $(fromList).children()
                .each(function () {
                    if ($(this).css('display') !== 'none')
                        _this.InsertItem(this, toList, fromList, false);
                });

            fromList.selectedItems = [];
            toList.selectedItems = [];

            this.ToggleHelpText();
        },

        Move: function (fromList, toList) {
            if (!fromList.selectedItems)
                return;
            var items = [];
            var i;
            for (i = 0; i < fromList.selectedItems.length; i++) {
                if (fromList.selectedItems[i].style.display !== 'none') {
                    items.push(fromList.selectedItems[i]);
                }
            }
            fromList.selectedItems = [];
            for (i = 0; i < items.length; i++) {
                this.InsertItem(items[i], toList, fromList, true);
            }

            this.ToggleHelpText();
        },

        MoveUp: function (list) {
            if (!list.selectedItems) {
                return;
            }

            $(list.selectedItems).each(function () {
                var $this = $(this);
                $this.insertBefore($this.prev());
            });
        },

        MoveDown: function (list) {
            if (!list.selectedItems) {
                return;
            }

            $(list.selectedItems).each(function () {
                var $this = $(this);
                $this.insertAfter($this.next());
            });
        }
    });

    return SwapList;
});
